import UserCenterNav from './src/main';

/* istanbul ignore next */
UserCenterNav.install = function(Vue) {
  Vue.component(UserCenterNav.name, UserCenterNav);
};

export default UserCenterNav;
